/**
 * Escolhe qual parcela o checkout exibe ao abrir.
 * Salvo em offer.settingsData.initialInstallments:
 *   "max" (ou ausente) = maior parcela disponível (comportamento padrão)
 *   "1", "2", ...      = abre já nessa parcela
 * O comprador continua podendo trocar a parcela no checkout.
 */

export const INITIAL_INSTALLMENTS_MAX = "max";

/** Lê a configuração salva no settingsData da oferta (aceita objeto ou string JSON). */
export function readInitialInstallments(settingsData: unknown): string {
    let settings: unknown = settingsData;
    if (typeof settings === "string") {
        try { settings = JSON.parse(settings); } catch { settings = null; }
    }
    const raw = settings && typeof settings === "object"
        ? (settings as Record<string, unknown>).initialInstallments
        : undefined;
    if (raw === undefined || raw === null || raw === "" || raw === INITIAL_INSTALLMENTS_MAX) return INITIAL_INSTALLMENTS_MAX;
    const n = parseInt(String(raw), 10);
    return Number.isFinite(n) && n >= 1 ? String(n) : INITIAL_INSTALLMENTS_MAX;
}

/** Normaliza settingsData (objeto ou string JSON) para objeto, preservando as demais chaves. */
export function parseSettingsData(settingsData: unknown): Record<string, unknown> {
    if (!settingsData) return {};
    if (typeof settingsData === "string") {
        try {
            const parsed = JSON.parse(settingsData);
            return parsed && typeof parsed === "object" ? parsed : {};
        } catch {
            return {};
        }
    }
    return typeof settingsData === "object" ? { ...(settingsData as Record<string, unknown>) } : {};
}

/** Garante que a parcela inicial não passe do parcelamento máximo da oferta. */
export function clampInitialInstallments(value: string, maxInstallments: number): string {
    if (value === INITIAL_INSTALLMENTS_MAX) return value;
    const n = parseInt(value, 10);
    if (!Number.isFinite(n) || n < 1) return INITIAL_INSTALLMENTS_MAX;
    if (n >= maxInstallments) return INITIAL_INSTALLMENTS_MAX;
    return String(n);
}
